export default __webpack_public_path__ + "static/media/javascript.06db8995.png";